<template>
  <DashboardLayout>
    <ToastManagerVue ref="toastManager" />
    <LoadingSpinner :isLoading="isLoading" />
    <div>
      <div class="overall-container">
        <div class="dashboard-main-container">
          <div class="header-container">
            <div class="profile-image-container">
              <!-- <div class="profile-image">
                <img
                  :src="
                    account_information.profile_picture ||
                    require(`@/assets/${defaultImage}`)
                  "
                  alt="Profile Image"
                />
                <input type="file" @change="onFileChange" id="file-input" />
                <label for="file-input" class="edit-icon">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="30" height="30" rx="15" fill="#979797" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M20.4919 7.5931L21.6172 8.71842C22.2757 9.3686 22.2757 10.4272 21.6172 11.0774L10.5892 22.1055H7.10486V18.6212L15.7739 9.94376L18.1329 7.5931C18.7831 6.94292 19.8417 6.94292 20.4919 7.5931ZM8.77199 20.4383L9.94731 20.4884L18.1329 12.2944L16.9576 11.1191L8.77199 19.3047V20.4383Z"
                      fill="white"
                    />
                  </svg>
                </label>
              </div> -->
            </div>
            <div class="header-container-details">
              <div class="header-container-details-first-div">
                <h4>
                  {{ account_information.firstName }}
                  {{ account_information.lastNameFirst }}
                </h4>
                <div class="header-container-details">
                  <!-- <div class="header-container-details-first-div">
              <h4>{{ user.name }}</h4>
            </div> -->
                  <div>Lagos</div>
                  <div>Member since 2024</div>
                </div>
                <div class="header-container-details-first-div-svg">
                  <svg
                    width="21"
                    height="24"
                    viewBox="0 0 21 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.85328 23.994C8.55763 23.5381 7.30397 22.9863 6.13428 22.2485C3.42901 20.5509 1.65949 18.1576 0.765736 15.1044C0.393837 13.8448 0.207887 12.5491 0.0999164 11.2415C-0.050043 9.54992 0.00994074 7.85238 0.0219375 6.16083C0.0219375 5.61498 0.0759229 5.06913 0.363845 4.57726C0.843715 3.74949 1.56352 3.30561 2.51126 3.23962C3.69294 3.14965 4.84463 2.9577 5.95433 2.51382C7.09402 2.06394 8.10175 1.41012 8.98951 0.570347C9.31942 0.252434 9.69132 0.0124986 10.1772 0.00050181C10.6751 -0.0114949 11.0709 0.19245 11.4129 0.52236C12.2106 1.27816 13.1044 1.90199 14.1121 2.35187C15.1678 2.82574 16.2775 3.08967 17.4292 3.19164C18.0471 3.24562 18.6589 3.28161 19.1987 3.63552C19.9485 4.12738 20.3504 4.8172 20.4044 5.71695C20.4824 7.06659 20.4704 8.41622 20.4344 9.76586C20.3804 11.8233 20.1405 13.8567 19.4567 15.8122C18.413 18.7994 16.4755 21.0428 13.7342 22.6024C12.7325 23.1722 11.6768 23.6161 10.5971 24H9.84728L9.85328 23.994ZM18.9828 8.71614C18.9828 8.4882 18.9828 8.26626 18.9828 8.03832C18.9828 7.33052 18.9828 6.61671 18.9648 5.9089C18.9528 5.20709 18.5809 4.7992 17.8791 4.70323C17.3752 4.63725 16.8714 4.61325 16.3675 4.52928C15.1858 4.33733 14.0641 3.98342 12.9964 3.43757C12.0487 2.9577 11.2029 2.33387 10.4351 1.60807C10.2732 1.45811 10.1532 1.46411 9.99724 1.60807C9.50537 2.06394 8.98951 2.49583 8.42566 2.86173C6.71613 3.97742 4.83263 4.52927 2.81118 4.66124C1.92942 4.72122 1.47954 5.12311 1.47954 5.9029C1.47954 7.48647 1.40756 9.07005 1.50354 10.6536C1.59351 12.1052 1.79146 13.5388 2.22334 14.9305C2.82318 16.8739 3.8609 18.5475 5.39648 19.8911C6.74612 21.0728 8.2997 21.8766 9.97324 22.4824C10.1532 22.5484 10.3211 22.5304 10.4951 22.4704C11.2869 22.1825 12.0607 21.8466 12.7985 21.4387C14.52 20.491 15.9536 19.2433 17.0033 17.5637C17.8011 16.2801 18.287 14.8825 18.5809 13.4069C18.8928 11.8533 18.9648 10.2817 18.9648 8.71014L18.9828 8.71614Z"
                      fill="#126B4C"
                    />
                    <path
                      d="M10.2075 18.0067C6.90843 17.9947 4.20316 15.2654 4.22116 11.9783C4.23915 8.68522 6.95642 5.99195 10.2435 6.00395C13.5426 6.01594 16.2539 8.7452 16.2299 12.0383C16.2119 15.3314 13.4946 18.0247 10.2075 18.0127V18.0067ZM10.2255 16.5371C12.7389 16.5371 14.7603 14.5096 14.7543 11.9963C14.7543 9.489 12.7329 7.47355 10.2315 7.47355C7.71821 7.47355 5.69076 9.489 5.69076 12.0023C5.69076 14.5156 7.71221 16.5371 10.2255 16.5371Z"
                      fill="#126B4C"
                    />
                    <path
                      d="M9.16887 14.6429C8.95293 14.6429 8.77298 14.5589 8.62302 14.409C8.22113 14.0071 7.81324 13.6112 7.41734 13.2033C7.11143 12.8854 7.11143 12.4655 7.39335 12.1716C7.68127 11.8716 8.11315 11.8656 8.44307 12.1716C8.64101 12.3515 8.82696 12.5375 9.00691 12.7354C9.13288 12.8734 9.21086 12.8614 9.34282 12.7354C10.1826 11.8896 11.0224 11.0439 11.8681 10.2041C12.216 9.86219 12.6599 9.85019 12.9658 10.1621C13.1938 10.402 13.2358 10.7439 13.0678 11.0259C13.0198 11.1039 12.9598 11.1818 12.8939 11.2478C11.8561 12.2915 10.8124 13.3352 9.76871 14.373C9.60675 14.5349 9.4208 14.6609 9.17487 14.6549L9.16887 14.6429Z"
                      fill="#126B4C"
                    />
                  </svg>
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.45841 0C10.8004 0 14.1364 0 17.4784 0C19.8064 2.328 22.1284 4.65 24.4564 6.978V16.998C22.1944 19.26 19.9324 21.516 17.6704 23.784C17.5204 23.934 17.3704 24 17.1604 24C14.0404 24 10.9204 24 7.8004 24C7.5784 24 7.4224 23.94 7.26641 23.784C5.07641 21.582 2.8804 19.386 0.678403 17.196C0.522403 17.04 0.462402 16.884 0.462402 16.662C0.468402 13.62 0.474402 10.578 0.462402 7.536C0.462402 7.152 0.576407 6.888 0.846407 6.624C3.06041 4.428 5.2624 2.214 7.4704 0.00600014L7.45841 0ZM6.1204 11.988C6.1204 12.774 6.1204 13.566 6.1204 14.352C6.1204 14.52 6.16241 14.646 6.28241 14.766C7.42241 15.9 8.55641 17.034 9.69041 18.174C9.80441 18.288 9.91841 18.336 10.0804 18.336C11.6704 18.336 13.2604 18.336 14.8564 18.336C15.0184 18.336 15.1384 18.282 15.2464 18.174C16.3804 17.034 17.5144 15.9 18.6544 14.766C18.7684 14.652 18.8164 14.532 18.8164 14.376C18.8164 12.786 18.8164 11.196 18.8164 9.6C18.8164 9.438 18.7624 9.318 18.6544 9.21C17.5144 8.076 16.3804 6.942 15.2464 5.802C15.1324 5.688 15.0124 5.64 14.8564 5.64C13.2664 5.64 11.6764 5.64 10.0804 5.64C9.91841 5.64 9.79841 5.694 9.69041 5.802C8.55641 6.942 7.42241 8.076 6.28241 9.21C6.16241 9.33 6.1204 9.456 6.1204 9.624C6.1264 10.41 6.1204 11.202 6.1204 11.988ZM4.68041 11.988C4.68041 11.262 4.68041 10.536 4.68041 9.81C4.68041 9.63 4.6324 9.528 4.4524 9.456C3.6784 9.144 2.9104 8.826 2.1424 8.496C1.9564 8.418 1.9024 8.448 1.9024 8.658C1.9024 10.878 1.9024 13.104 1.9024 15.324C1.9024 15.51 1.93841 15.564 2.13041 15.486C2.90441 15.156 3.68441 14.832 4.46441 14.52C4.62641 14.454 4.6864 14.358 4.6864 14.184C4.6804 13.452 4.6864 12.72 4.6864 11.982L4.68041 11.988ZM12.4744 1.428C11.3644 1.428 10.2604 1.428 9.1504 1.428C8.89841 1.428 8.89241 1.44 8.98841 1.68C9.30641 2.442 9.6244 3.204 9.9364 3.972C10.0024 4.14 10.0984 4.206 10.2844 4.206C11.7424 4.2 13.2004 4.2 14.6584 4.206C14.8444 4.206 14.9404 4.146 15.0064 3.972C15.3124 3.204 15.6364 2.442 15.9544 1.68C16.0564 1.44 16.0504 1.428 15.7744 1.428C14.6764 1.428 13.5724 1.428 12.4744 1.428ZM12.4624 22.554C13.5784 22.554 14.6944 22.554 15.8104 22.554C15.9904 22.554 16.0564 22.518 15.9724 22.332C15.6424 21.558 15.3184 20.778 15.0064 19.998C14.9404 19.836 14.8504 19.776 14.6764 19.776C13.2124 19.776 11.7424 19.776 10.2784 19.776C10.1044 19.776 10.0144 19.836 9.94841 19.998C9.63641 20.766 9.31841 21.528 9.0004 22.29C8.8924 22.542 8.8984 22.548 9.1684 22.548C10.2664 22.548 11.3704 22.548 12.4684 22.548L12.4624 22.554ZM23.0344 11.994C23.0344 10.878 23.0344 9.762 23.0344 8.646C23.0344 8.448 22.9804 8.418 22.8064 8.49C22.0264 8.82 21.2404 9.144 20.4544 9.468C20.3044 9.528 20.2624 9.618 20.2624 9.768C20.2624 11.244 20.2624 12.714 20.2624 14.19C20.2624 14.352 20.3164 14.442 20.4724 14.508C21.2524 14.826 22.0324 15.144 22.8064 15.474C22.9984 15.552 23.0464 15.516 23.0464 15.312C23.0404 14.202 23.0464 13.098 23.0464 11.988L23.0344 11.994ZM17.4484 2.046C17.3464 2.046 17.3404 2.136 17.3164 2.196C16.9864 2.982 16.6684 3.768 16.3384 4.548C16.2784 4.692 16.3024 4.788 16.4104 4.902C17.4604 5.946 18.5104 6.996 19.5544 8.046C19.6684 8.16 19.7704 8.184 19.9264 8.118C20.6944 7.794 21.4624 7.47 22.2364 7.158C22.4164 7.086 22.4524 7.038 22.2964 6.882C20.7124 5.31 19.1404 3.732 17.5624 2.154C17.5264 2.118 17.4844 2.082 17.4484 2.046ZM5.1604 15.816C5.1304 15.828 5.08841 15.84 5.04041 15.858C4.24841 16.188 3.45641 16.518 2.66441 16.842C2.50241 16.908 2.50241 16.962 2.62241 17.082C4.21241 18.666 5.8024 20.256 7.3864 21.846C7.5124 21.972 7.5604 21.948 7.6264 21.798C7.9504 21.006 8.2804 20.214 8.6104 19.422C8.6644 19.296 8.6524 19.206 8.5504 19.11C7.4824 18.048 6.4204 16.98 5.3584 15.918C5.3104 15.87 5.2564 15.816 5.1664 15.822L5.1604 15.816ZM17.4244 21.936C17.4904 21.924 17.5264 21.87 17.5684 21.822C19.1464 20.244 20.7244 18.666 22.3024 17.094C22.4344 16.962 22.4404 16.902 22.2544 16.83C21.4744 16.512 20.6944 16.194 19.9204 15.864C19.7644 15.798 19.6624 15.822 19.5484 15.942C19.2424 16.26 18.9244 16.572 18.6064 16.884C17.8864 17.604 17.1604 18.33 16.4404 19.05C16.3564 19.134 16.2484 19.212 16.3144 19.368C16.6564 20.19 16.9984 21.012 17.3344 21.828C17.3524 21.87 17.3644 21.918 17.4184 21.93L17.4244 21.936ZM8.64641 4.68C8.64641 4.68 8.6224 4.608 8.6044 4.566C8.2744 3.774 7.9444 2.982 7.6204 2.19C7.5544 2.022 7.49441 2.034 7.38041 2.148C6.81641 2.718 6.2464 3.288 5.6764 3.852C4.6624 4.866 3.6484 5.88 2.6284 6.894C2.5144 7.008 2.47241 7.074 2.66441 7.146C3.45041 7.464 4.23641 7.794 5.02241 8.118C5.14841 8.172 5.2504 8.178 5.3584 8.07C6.4204 7.002 7.4824 5.94 8.5504 4.878C8.5984 4.83 8.65241 4.776 8.64041 4.68H8.64641Z"
                      fill="#126B4C"
                    />
                  </svg>
                  <svg
                    width="30"
                    height="24"
                    viewBox="0 0 30 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.8984 2.14477C15.4984 2.15677 13.3805 2.93676 11.5445 4.47874C11.3405 4.65274 11.1245 4.81474 10.8485 4.84474C10.3685 4.90474 9.9305 4.67074 9.7385 4.25675C9.54051 3.83075 9.6425 3.32076 10.0085 3.00276C11.1185 2.02477 12.3545 1.24478 13.7525 0.770783C18.4924 -0.837199 22.7344 0.0687911 26.3643 3.50675C28.3683 5.40273 29.5083 7.79671 29.8263 10.5507C30.2643 14.3726 29.1183 17.6906 26.4543 20.4386C24.5643 22.3826 22.2424 23.5405 19.5364 23.8885C16.0084 24.3445 12.8825 23.3965 10.1465 21.1346C9.5885 20.6726 9.4805 20.0126 9.8825 19.5386C10.2845 19.0586 10.9505 19.0406 11.5025 19.5086C12.8405 20.6486 14.3704 21.3986 16.0984 21.7166C21.0604 22.6405 25.8363 19.7426 27.3663 14.9066C29.1423 9.28469 25.4163 3.23076 19.5904 2.27677C19.0324 2.18677 18.4684 2.13877 17.8984 2.14477Z"
                      fill="#126B4C"
                    />
                    <path
                      d="M18.4562 8.48025C18.4562 9.18225 18.4742 9.89024 18.4502 10.5922C18.4382 10.9222 18.5522 11.1502 18.7802 11.3722C20.0222 12.5962 21.2522 13.8262 22.4702 15.0622C23.0822 15.6802 22.8242 16.6462 22.0022 16.8562C21.5642 16.9702 21.2162 16.7962 20.9102 16.4842C19.7042 15.2722 18.4922 14.0722 17.2862 12.8602C16.2062 11.7742 16.3262 12.0742 16.3262 10.5562C16.3262 9.03225 16.3262 7.50227 16.3262 5.97828C16.3262 5.46829 16.6922 5.04229 17.1722 4.95229C17.6702 4.85629 18.1802 5.13829 18.3602 5.60629C18.4442 5.81628 18.4502 6.04428 18.4502 6.26628C18.4502 7.00427 18.4502 7.74226 18.4502 8.47425L18.4562 8.48025Z"
                      fill="#126B4C"
                    />
                    <path
                      d="M5.61084 6.15834C6.96682 6.15834 8.32281 6.15834 9.67879 6.15834C10.1528 6.15834 10.5008 6.37434 10.6988 6.80634C10.8848 7.22033 10.7888 7.59833 10.5008 7.93432C10.2788 8.19232 9.96679 8.28832 9.6368 8.28832C6.96083 8.28832 4.27886 8.29432 1.60288 8.28832C0.936891 8.28832 0.438894 7.78433 0.456894 7.19633C0.480893 6.57834 0.948889 6.15834 1.63888 6.15234C2.96487 6.15234 4.28485 6.15234 5.61084 6.15234V6.15834Z"
                      fill="#126B4C"
                    />
                    <path
                      d="M8.33443 17.8589C6.99045 17.8589 5.64647 17.8589 4.30249 17.8589C3.84649 17.8589 3.50449 17.6489 3.30049 17.2349C3.11449 16.8509 3.1745 16.4849 3.4205 16.1489C3.68449 15.8009 4.06249 15.717 4.47648 15.723C6.13246 15.723 7.78245 15.723 9.43843 15.723C10.3984 15.723 11.3584 15.723 12.3184 15.723C12.9004 15.723 13.3144 16.0049 13.4644 16.4729C13.6924 17.1689 13.1764 17.8529 12.3964 17.8589C11.0404 17.8709 9.68442 17.8589 8.32844 17.8589H8.33443Z"
                      fill="#126B4C"
                    />
                    <path
                      d="M7.01472 10.9648C8.3827 10.9648 9.74469 10.9648 11.1127 10.9648C11.5867 10.9648 11.9767 11.2768 12.1087 11.7268C12.2347 12.1708 12.0547 12.6448 11.6587 12.9028C11.4847 13.0168 11.2927 13.0648 11.0827 13.0648C8.3587 13.0648 5.64073 13.0648 2.91676 13.0648C2.29276 13.0648 1.84877 12.6268 1.84277 12.0328C1.84277 11.4088 2.26876 10.9768 2.91676 10.9708C4.28474 10.9708 5.64673 10.9708 7.01472 10.9708V10.9648Z"
                      fill="#126B4C"
                    />
                  </svg>
                </div>
              </div>
              <!-- <div>
                {{ account_information.city }}, {{ account_information.state }}
              </div>
              <div>
                <span
                  v-for="star in 5"
                  :key="star"
                  class="star"
                  :class="{ filled: star <= 5 }"
                  >★</span
                >
                <span>4</span>
              </div> -->
            </div>
          </div>
          <div class="the-container">
            <div class="the-container-first">
              <div class="account-info-header">
                <h4>Account Information</h4>
                <div
                  style="cursor: pointer"
                  @click="showModal('account_information')"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.0576 0.586953L17.4076 1.93695C18.1976 2.71695 18.1976 3.98695 17.4076 4.76695L4.17756 17.997H-0.00244141V13.817L10.3976 3.40695L13.2276 0.586953C14.0076 -0.193047 15.2776 -0.193047 16.0576 0.586953ZM1.99756 15.997L3.40756 16.057L13.2276 6.22695L11.8176 4.81695L1.99756 14.637V15.997Z"
                      fill="#979797"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="details-container">
              <div>
                <h3>First Name:</h3>
                <p>{{ account_information.firstName }}</p>
              </div>
              <div>
                <h3>Last Name:</h3>
                <p>{{ account_information.lastName }}</p>
              </div>
              <!-- <div>
                <h3>City:</h3>
                <p>{{ account_information.city }}</p>
              </div>
              <div>
                <h3>State:</h3>
                <p>{{ account_information.state }}</p>
              </div> -->
              <div>
                <h3>Mobile Number:</h3>
                <p>{{ account_information.phone }}</p>
              </div>
              <div>
                <h3>Email:</h3>
                <p>{{ account_information.email }}</p>
              </div>
            </div>
            <div class="change-password">
              <p>Change Password</p>
              <svg
                @click="showModal('password')"
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.00009 0L0.590088 1.41L5.17009 6L0.590088 10.59L2.00009 12L8.00009 6L2.00009 0Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
          <div class="the-container">
            <div class="the-container-first">
              <div class="account-info-header">
                <h4>Membership Information</h4>
                <div
                  style="cursor: pointer"
                  @click="showModal('membership_information')"
                >
                  <!-- <svg
                width="166"
                height="18"
                viewBox="0 0 166 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M164.057 0.58793L165.407 1.93793C166.197 2.71793 166.197 3.98793 165.407 4.76793L152.177 17.9979H147.997V13.8179L158.397 3.40793L161.227 0.58793C162.007 -0.19207 163.277 -0.19207 164.057 0.58793ZM149.997 15.9979L151.407 16.0579L161.227 6.22793L159.817 4.81793L149.997 14.6379V15.9979Z"
                  fill="#979797"
                />
              </svg> -->
                </div>
              </div>
            </div>
            <div class="details-container">
              <div>
                <h3>Date Joined</h3>
                <p>01, April 2023</p>
              </div>
              <div>
                <h3>Account Status</h3>
                <p>Active</p>
              </div>
              <div>
                <h3>Membership plan</h3>
                <p>
                  Basic
                  <span style="color: var(--state-info)">(Upgrade)</span>
                </p>
              </div>
            </div>
            <div class="delete-account">
              <p @click="showModal('delete_account')">Delete my account</p>
              <svg
                @click="showModal('delete_account')"
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.00009 0L0.590088 1.41L5.17009 6L0.590088 10.59L2.00009 12L8.00009 6L2.00009 0Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
          <div class="the-container">
            <div class="the-container-first">
              <div class="account-info-header">
                <h4>Privacy Preferences</h4>
                <div style="cursor: pointer">
                  <!-- <svg
                width="166"
                height="18"
                viewBox="0 0 166 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M164.057 0.58793L165.407 1.93793C166.197 2.71793 166.197 3.98793 165.407 4.76793L152.177 17.9979H147.997V13.8179L158.397 3.40793L161.227 0.58793C162.007 -0.19207 163.277 -0.19207 164.057 0.58793ZM149.997 15.9979L151.407 16.0579L161.227 6.22793L159.817 4.81793L149.997 14.6379V15.9979Z"
                  fill="#979797"
                />
              </svg> -->
                </div>
              </div>
            </div>
            <div class="details-last-container">
              <div>
                <p>Email about product features</p>
                <ToggleSwitch v-model="product_features" />
              </div>
              <div>
                <p>Email Notifications</p>
                <ToggleSwitch v-model="email_notifications" />
              </div>
            </div>
          </div>

          <!-- Job Details Modal -->
          <GenericModal
            :isVisible="isMainModalVisible"
            :title="modalTitle"
            @close="hideModal"
            @confirm="handleConfirm"
          >
            <template v-if="currentModal === 'account_information'">
              <div class="inputs-div">
                <CustomInput
                  label="First Name"
                  v-model="account_information.firstName"
                  placeholder="First Name"
                  type="text"
                  focusColor="#17865F"
                  defaultColor="#979797"
                />
                <CustomInput
                  label="Last Name"
                  v-model="account_information.lastName"
                  placeholder="Last Name"
                  type="text"
                  focusColor="#17865F"
                  defaultColor="#979797"
                />
                <!-- <div :class="['custom-multiselect', 'state-select']">
                
                  <label for="state">State</label>
                  <Multiselect
                    id="state"
                    label="text"
                    v-model="account_information.state"
                    track-by="value"
                    placeholder="State"
                    class="custom-multiselect"
                    :options="stateOptions"
                    :disabled="true"
                  >
                    <template #caret>
                      <svg
                        width="12"
                        height="8"
                        viewBox="0 0 12 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 1.70688L10.59 0.296875L6 4.87687L1.41 0.296875L0 1.70688L6 7.70688L12 1.70688Z"
                          fill="#979797"
                        />
                      </svg>
                    </template>
                  </Multiselect>
                </div> -->
                <!-- <div :class="['custom-multiselect', 'city-select']">
                  <label for="lga">Lga</label>
                  <Multiselect
                    id="lga"
                    label="text"
                    v-model="account_information.city"
                    track-by="value"
                    placeholder="City"
                    class="custom-multiselect"
                    :options="cityOptions"
                  >
                    <template #caret>
                      <svg
                        width="12"
                        height="8"
                        viewBox="0 0 12 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 1.70688L10.59 0.296875L6 4.87687L1.41 0.296875L0 1.70688L6 7.70688L12 1.70688Z"
                          fill="#979797"
                        />
                      </svg>
                    </template>
                    <template #clear></template>
                 
                  </Multiselect>
                </div> -->

                <CustomInput
                  label="Mobile Number"
                  v-model="account_information.phone"
                  placeholder="Mobile Number"
                  type="text"
                  focusColor="#17865F"
                  defaultColor="#979797"
                />
                <CustomInput
                  label="Email"
                  v-model="account_information.email"
                  placeholder="Email"
                  type="text"
                  focusColor="#17865F"
                  defaultColor="#979797"
                />
              </div>
              <BaseButton
                :label="isProfileUpdate ? 'Updating...' : 'Update'"
                backgroundColor="var(--s-pink-normal)"
                textColor="var(--state-white)"
                height="60px"
                width="400px"
                @click="handleProfileUpdate"
              />
            </template>
            <template v-if="currentModal === 'password'">
              <div class="inputs-div">
                <CustomInput
                  label="Old Password"
                  v-model="oldpassword"
                  placeholder="Old Password"
                  type="text"
                  focusColor="#17865F"
                  defaultColor="#979797"
                />
                <CustomInput
                  label="New Password"
                  v-model="newpassword"
                  placeholder="New Password"
                  type="text"
                  focusColor="#17865F"
                  defaultColor="#979797"
                />
              </div>
              <BaseButton
                :label="isProfileUpdate ? 'Updating...' : 'Update'"
                backgroundColor="var(--s-pink-normal)"
                textColor="var(--state-white)"
                height="60px"
                width="100%"
                @click="hideModal"
              />
            </template>
            <template v-if="currentModal === 'delete_account'">
              <!-- Availability form content -->

              <div class="availability-container">
                <div style="max-width: 400px">
                  <p>Are you sure you want to delete your account?</p>
                  <div class="delete-div">
                    <BaseButton
                      label="Delete Account"
                      backgroundColor="var(--s-pink-normal)"
                      textColor="var(--state-white)"
                      height="60px"
                      width="200px"
                      @click="hideModal"
                    />
                    <BaseButton
                      label="No"
                      backgroundColor="transparent"
                      textColor="black"
                      height="60px"
                      width="150px"
                      @click="hideModal"
                    />
                  </div>
                </div>
              </div>
            </template>
          </GenericModal>
        </div>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import "@vueform/multiselect/themes/default.css";
import GenericModal from "@/components/GenericModal.vue";
import CustomInput from "@/components/CustomInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";

import "@vueform/multiselect/themes/default.css";
import statesData from "@/data/states.js";
import Request from "@/utils/apiclient.js";
import DashboardLayout from "@/views/Dashboard/Caregiver/IndexPage.vue";
import { formatErrorMessages } from "@/utils/errorHandler";
import ToastManagerVue from "@/components/ToastAlert/ToastManager.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
export default {
  name: "AccountCareSeekerPage",
  components: {
    GenericModal,
    BaseButton,
    CustomInput,
    ToggleSwitch,

    DashboardLayout,
    ToastManagerVue,
    LoadingSpinner,
  },
  setup() {
    const isLoading = ref(true);
    const account_information = ref({
      firstName: "",
      lastNameFirst: "",
      state: "",
      city: "",
      phone: "",
      email: "",
      profile_picture: null,
    });

    const userData = ref(null);
    const userProfile = JSON.parse(localStorage.getItem("_userProfile"));
    const fetchProfile = () => {
      const request = new Request(`/profile/${userProfile.id}/`);
      request.get((res, err) => {
        isLoading.value = false;
        if (err) {
          console.error("Error:", err);
        } else {
          console.log("here is profile data", res);
          userData.value = res;
          account_information.value.firstName = res.first_name;
          account_information.value.lastNameFirst = res.last_name.charAt(0);
          account_information.value.email = res.email;
          // account_information.value.state = res.care_giver.state.charAt(0);
          // account_information.value.state =
          //   res.care_giver.state.charAt(0).toUpperCase() +
          //   res.care_giver.state.slice(1);

          // account_information.value.city = formatString(res.care_giver.lga);

          account_information.value.phone = res.phone;
          account_information.value.profile_picture = res.profile_picture;
          account_information.value.lastName = res.last_name;
        }
      });
    };
    onMounted(() => {
      fetchProfile();
    });

    const toastManager = ref(null);
    const showToast = (msg, statusValue) => {
      toastManager.value.addToast(msg, statusValue);
    };

    // Sample data
    const stateOptions = statesData.states.map((state) => ({
      value: state.state,
      text: state.state,
    }));

    const cityOptions = ref([]);

    const updateCityOptions = (state) => {
      const selectedStateData = statesData.states.find(
        (s) => s.state === state
      );
      cityOptions.value = selectedStateData
        ? selectedStateData.lgas.map((lga) => ({ value: lga, text: lga }))
        : [];
    };
    const product_features = ref(false);
    const email_notifications = ref(false);
    const jobs = ref([
      {
        id: 1,
        posted: "5 minutes",
        title: "Senior Care Needed",
        budget: "₦20,000",
        description:
          "I need a sit in care giver for my mom of 75 years I need a sit in care giver for my mom of 75 years I need a sit in care giver for my mom of 75 years. I need a sit in care giver for ..",
        tags: ["Bathing / Dressing", "Special Care"],
      },
      {
        id: 2,
        posted: "5 minutes",
        title: "Senior Care Needed",
        budget: "₦20,000",
        description:
          "I need a sit in care giver for my mom of 75 years I need a sit in care giver for my mom of 75 years I need a sit in care giver for my mom of 75 years. I need a sit in care giver for ..",
        tags: ["Bathing / Dressing", "Special Care"],
      },
      {
        id: 3,
        posted: "5 minutes",
        title: "Senior Care Needed",
        budget: "₦20,000",
        description:
          "I need a sit in care giver for my mom of 75 years I need a sit in care giver for my mom of 75 years I need a sit in care giver for my mom of 75 years. I need a sit in care giver for ..",
        tags: ["Bathing / Dressing", "Special Care"],
      },
      {
        id: 4,
        posted: "5 minutes",
        title: "Senior Care Needed",
        budget: "₦20,000",
        description:
          "I need a sit in care giver for my mom of 75 years I need a sit in care giver for my mom of 75 years I need a sit in care giver for my mom of 75 years. I need a sit in care giver for ..",
        tags: ["Bathing / Dressing", "Special Care"],
      },
      // Add more job objects here
    ]);

    const user = ref({
      image: "profileimage.png",
      name: "Jane Adeyemi",
      title: "Professional Caregiver",
      availability: "Mondays - Friday",
      categories: ["Child Care", "Senior Care", "Academic Care", "Home Care"],
      preferences: "Live Out",
      rate: "N5000 / day",
      education: "University of Lagos",
    });

    const searchQuery = ref("");
    const currentTab = ref("myFeed");
    const isModalVisible = ref(false);
    const selectedJob = ref({});

    // Computed property to filter jobs based on search query
    const filteredJobs = computed(() => {
      return jobs.value.filter((job) =>
        job.title.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    // Method to set the current tab
    const setTab = (tab) => {
      currentTab.value = tab;
    };

    // Method to save a job (dummy implementation)
    const saveJob = (jobId) => {
      console.log(`Job ${jobId} saved!`);
    };

    // Method to open job details modal
    const openJobDetails = (job) => {
      selectedJob.value = job;
      isModalVisible.value = true;
    };

    // Method to close job details modal
    const closeJobDetails = () => {
      isModalVisible.value = false;
      selectedJob.value = null;
    };

    const profileImage = ref(null);
    const defaultImage = ref("woman.png");

    const isMainModalVisible = ref(false);
    const currentModal = ref("");
    const modalTitle = ref("");

    const showModal = (modalType) => {
      currentModal.value = modalType;
      modalTitle.value = getModalTitle(modalType);
      isMainModalVisible.value = true;
    };

    const hideModal = () => {
      isMainModalVisible.value = false;
    };
    const institution = ref("University of Lagos");
    const getModalTitle = (modalType) => {
      switch (modalType) {
        case "account_information":
          return "Update your account information";
        case "password":
          return "Update your password";
        case "delete_account":
          return "Delete my account";
        default:
          return "";
      }
    };

    const handleConfirm = () => {
      hideModal();
    };
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    // replace this mon,wed with values coming from endpoint
    const selectedDays = ref(["Mon", "Wed"]);
    const showSpecificTime = ref(false);

    const toggleDay = (day) => {
      if (selectedDays.value.includes(day)) {
        selectedDays.value = selectedDays.value.filter((d) => d !== day);
      } else {
        selectedDays.value.push(day);
      }
    };
    // start services

    // preferences start
    const preferences = ref("Both");
    const preferencesOptions = ref([
      {
        value: "Live in",
        text: "Live in",
      },
      {
        value: "Live out",
        text: "Live out",
      },
      {
        value: "Both",
        text: "Both",
      },
    ]);
    const hideLanguageDropdown = ref(true);

    const toggleLanguages = () => {
      hideLanguageDropdown.value = !hideLanguageDropdown.value;
    };

    const aboutme = ref("bla bla bla bla bla bla");
    const rate = ref(50000); // Initial rate value
    watch(
      () => account_information.value.state,
      (newState) => {
        updateCityOptions(newState);
      }
    );
    const isProfileUpdate = ref(false);
    const handleProfileUpdate = () => {
      if (isProfileUpdate.value) return;
      isProfileUpdate.value = true;
      let lga = account_information.value.city.toLowerCase().replace(/ /g, "_");
      const payload = {
        first_name: account_information.value.firstName,
        last_name: account_information.value.lastName,
        email: account_information.value.email,
        lga: lga,
        phone: account_information.value.phone,
      };
      console.log("payload fam", payload);
      const rawData = JSON.stringify(payload);
      console.log("raw data", rawData);
      const request = new Request(`/profile/${userProfile.id}/`);
      request.patch(rawData, (data, error) => {
        isProfileUpdate.value = false;
        if (error) {
          console.log("data error", error);
          if (error.status === "failure") {
            return showToast(error.message, "error");
          }
          const errorMessages = formatErrorMessages(error);
          errorMessages.forEach((message) => showToast(message, "error"));
        } else {
          console.log("Success:", data);
          fetchProfile();
          hideModal();
          showToast("Profile Update Successful", "success");
        }
      });
    };

    // Call updateCityOptions on mounted to set initial city options based on default state
    onMounted(() => {
      updateCityOptions(account_information.value.state);
    });

    const onFileChange = (event) => {
      const file = event.target.files[0];
      if (file && file.size <= 1048576) {
        const formData = new FormData();
        formData.append("profile_picture", file);

        const request = new Request(`/profile/${userProfile.id}/`);
        request.patchFormData(formData, (data, error) => {
          if (error) {
            showToast("Profile Picture Update Failed", "error");
            console.error("File upload error:", error);
          } else {
            console.log("data", data);
            showToast("Profile Picture Update Successful", "success");
            // profileImage.value = URL.createObjectURL(file);
            fetchProfile();
          }
        });
      } else {
        showToast("File size should be less than 1MB", "error");
        console.error("File size should be less than 1MB");
      }
    };
    return {
      jobs,
      user,
      searchQuery,
      currentTab,
      filteredJobs,
      setTab,
      saveJob,
      openJobDetails,
      closeJobDetails,
      selectedJob,
      isModalVisible,

      defaultImage,
      profileImage,
      isMainModalVisible,
      currentModal,
      modalTitle,
      showModal,
      hideModal,
      handleConfirm,
      getModalTitle,
      days,
      selectedDays,
      showSpecificTime,
      toggleDay,

      toggleLanguages,
      preferences,
      preferencesOptions,

      hideLanguageDropdown,
      aboutme,
      institution,
      rate,
      product_features,
      email_notifications,
      account_information,
      stateOptions,
      cityOptions,

      updateCityOptions,
      onFileChange,
      toastManager,
      handleProfileUpdate,
      isProfileUpdate,
      isLoading,
    };
  },
};
</script>

<style scoped>
.overall-container {
  display: flex;
  width: 100%;
  padding-left: 188px;
}
.login-container {
  max-width: 400px;
  margin: auto;
}

h2 {
  margin-bottom: 20px;
  margin-top: 32px;
  font-size: 24px;
  font-weight: 700;
  line-height: 29.05px;
  letter-spacing: 0.5px;
  text-align: center;
}

.login-button {
  width: 100%;
  background-color: var(--s-pink-normal);
  border: none;
  border-radius: 40px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 10px;
  padding: 16px 24px 16px 24px;
}

.login-button:hover {
  background-color: var(--s-pink-normal-hover);
}

.forgot-password {
  display: block;
  margin-bottom: 34px;
  color: var(--s-green-normal);
  text-decoration: none;
  text-align: center;

  font-size: 14px;
  font-weight: 400;
  line-height: 23.8px;
  letter-spacing: 0.5px;
  text-align: center;
}

.forgot-password:hover {
  color: var(--s-green-normal-hover);
}

.google-login,
.apple-login {
  width: 100%;
  padding: 10px 67px;
  border-radius: 12px;
  border: 1px solid var(--s-green-normal);
  color: #000;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  gap: 10px;
  font-size: var(--font-body-large-regular-size);
  font-weight: var(--font-weight-regular);
  line-height: 34px;
  font-family: var(--font-family);
  white-space: nowrap;
  letter-spacing: 0.5px;
  text-align: left;
  background-color: transparent;
}

.google-login img,
.apple-login img {
  width: 40.67px;
  height: 40.67px;
}

/* .google-login:hover,
.apple-login:hover {
  background-color: #f5f5f5;
} */
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #000;

  font-size: 20px;
  font-weight: 400;
  line-height: 34px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-bottom: 16px;
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #979797;
}
.separator:not(:empty)::before {
  margin-right: 8px;
}
.separator:not(:empty)::after {
  margin-left: 8px;
}
.join-now:hover {
  background-color: var(--s-pink-normal-hover);
}
.login-form {
  padding-bottom: 200px;
}

.dashboard-main-container {
  width: 1168px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  margin-top: 33px;
}

.first-dashboard-container {
  width: 100%;
  width: 772px;
  box-sizing: border-box;
}
.second-dashboard-container {
  width: 100%;
  width: 372px;
  box-sizing: border-box;
  padding-top: 76px;
}
h1 {
  font-size: 36px;
  font-weight: 300;
  line-height: 52px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #000000;
  margin-top: 0px;
  margin-bottom: 24px;
}
.search-wrapper input {
  border: 1px solid #979797 !important;
  width: 575px;
  height: 64px;
  padding: 10px 10px 10px 70px;
  gap: 16px;
  border-radius: 12px;
  border: 1px;
  box-sizing: border-box;
  background-color: transparent;
}
.search-wrapper input::placeholder {
  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  color: #979797;
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
}
.search-icon {
  position: absolute;
  left: 20px;
}

.active {
  border-bottom: 3px solid var(--s-pink-normal);
}
.active p {
  color: var(--s-pink-normal) !important;
  font-weight: var(--font-weight-bold) !important;
}
.single-tab {
  padding: 0px 20.5px 4px 20.5px;
  cursor: pointer;
}
.multiselect-single-label {
  padding-left: 0px !important;
}
.tabs {
  display: flex;
  justify-content: flex-start;
  margin-top: 42px;
}
.tabs p {
  color: #0a3828;
  font-size: var(--font-body-normal-regular-size);
  line-height: var(--font-body-normal-regular-line-height);
  font-weight: var(--font-weight-regular);
}
.jobs-container {
  padding-top: 32px;
}
.job {
  padding: 34px 16px 34px 0px;
  border-bottom: 0.5px solid black;
  cursor: pointer;
}
.job-header-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  margin-bottom: 10px;
}
.job-header-content p {
  font-size: 12px;
  font-weight: 400;
  line-height: 20.4px;
  letter-spacing: 0.5px;
}
.job-header-content-job-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.job-header-content-job-title h2 {
  margin: 0px;

  font-size: 20px;
  font-weight: 500;
  line-height: 34px;
  letter-spacing: 0.5px;
  text-align: left;
}
.job-body-content p {
  font-size: 14px;
  font-weight: 400;
  line-height: 23.8px;
  letter-spacing: 0.5px;
  margin: 0px;
  padding: 0px;
}
.job-body-content {
  margin-bottom: 10px;
  display: flex;
}
.job-tag {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.job-tag span {
  padding: 10px;
  gap: 8px;
  border-radius: 12px;
  background-color: #ececec;
  font-size: 12px;
  font-weight: 400;
  line-height: 20.4px;
  letter-spacing: 0.5px;
  text-align: left;
}
.second-dashboard-container-main {
  display: flex;
  gap: 18px;
  flex-direction: column;
}
.second-dashboard-container-profile-div {
  background-color: #e8f3ef80;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 16px;
}
.second-dashboard-container-profile-div img {
  width: 71px;
  height: 71px;
  border-radius: 50%;
}
.second-dashboard-container-profile-settings {
  background-color: #e8f3ef80;
}
.second-dashboard-container-profile-div-user {
  display: flex;
  flex-direction: column;
}
.second-dashboard-container-profile-div-user h3 {
  margin: 0px;
  font-size: 20px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0.5px;
  text-align: left;
}
.second-dashboard-container-profile-div-user p {
  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: left;
}
.second-dashboard-container-profile-settings {
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.second-dashboard-container-profile-settings h4 {
  font-size: 20px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0.5px;
  margin: 0px;
}
.availability-header,
.categories-header,
.job-preferences-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.availability,
.categories,
.preferences p {
  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
}
.availability,
.categories,
.preferences {
  padding: 10px 0px 10px 0px;
}

/* start availability */
.availability-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-family: Arial, sans-serif;
}

h1 {
  color: #0a3828;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}

.days-container,
.times-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}

.day-button,
.time-button {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: white;
  cursor: pointer;
  transition: background-color 0.3s, border-color 0.3s;
}

.day-button.selected,
.time-button.selected {
  background-color: var(--s-pink-light-hover);
  border-color: var(--s-green-normal);
}

.specific-time-container {
  margin-bottom: 20px;
  margin-top: 29px;
}

.time-picker {
  display: flex;
  align-items: center;
  gap: 29px;
  margin-top: 10px;
  position: relative;
}

.time-picker select {
  padding: 16px 52px 16px 10px;

  border-radius: 12px;
  border: 1px solid #979797;
  background-color: white;
  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: left;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  position: relative;
  background: url('data:image/svg+xml;utf8,<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 1.70492L10.59 0.294922L6 4.87492L1.41 0.294921L-6.16331e-08 1.70492L6 7.70492L12 1.70492Z" fill="black"/></svg>')
    no-repeat right 26px center;
  background-size: 10px 6px;
}

.time-picker select::-ms-expand {
  display: none; /* Remove default arrow in Internet Explorer */
}

.next-button {
  background-color: #ff6978;
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.next-button:disabled {
  background-color: #ececec;
  color: #979797;
  cursor: not-allowed;
}

.days-container button {
  padding: 10px;
  gap: 10px;
  border-radius: 12px;
  border: 1px solid #979797;
  font-size: 14px;
  font-weight: 400;
  line-height: 23.8px;
  letter-spacing: 0.5px;
  text-align: left;
  background-color: transparent;
}

.specific-time-container label {
  text-align: left;
}

.add-times {
  color: #0063f7;
  text-decoration: none;
  text-align: left;
}
span {
  font-size: 14px;
  font-weight: 400;
  line-height: 23.8px;
  letter-spacing: 0.5px;
  text-align: left;
}
.bottom-text {
  margin-top: 29px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 23.8px;
  letter-spacing: 0.5px;
  text-align: center;
}
/* end availability */
/* start .categories */
input[type="checkbox"]:checked {
  border-color: var(--s-green-normal-active);
}

input[type="checkbox"]:checked::before {
  transform: scale(1);
}

.selected-options {
  margin-bottom: 16px;
  margin-top: 16px;
}
.selected-option {
  display: inline-block;
  background-color: var(--s-pink-light-hover);
  border-radius: 12px;
  padding: 10px;
  margin-right: 8px;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 20.4px;
  letter-spacing: 0.5px;

  color: #000000;
  border: 1px solid var(--s-green-normal-active);
}
.focus {
  border: 1px solid var(--s-green-normal);
}

.dropdown {
  display: flex;
  flex-wrap: wrap;
  border-radius: 5px;
}
.dropdown label {
  white-space: nowrap;
  font-size: 14px;
  font-weight: 400;
  line-height: 23.8px;
  letter-spacing: 0.5px;
  margin-left: 8px;
  color: #000000;
}

.option-container {
  width: 50%;
  box-sizing: border-box;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.care-button .category {
  margin-top: 10px;
}

.care-button {
  padding: 16px;
  gap: 10px;
  border-radius: 12px;
  border: 1px solid #979797;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  background-color: transparent;
  margin-top: 20px;
  flex-direction: column;
  box-sizing: border-box;
}
.care-button-first {
  display: flex;
  justify-content: space-between;
}
.care-button {
  max-height: 210px;
}
input[type="checkbox"] {
  appearance: none;
  width: 15px;
  height: 15px;
  border: 2px solid #979797;
  background-color: transparent;
  display: grid;
  place-content: center;
  transition: background-color 0.3s, border-color 0.3s;
}

input[type="checkbox"]::before {
  content: "";
  width: 10px;
  height: 10px;
  transform: scale(0);
  transition: transform 0.3s;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  background-color: var(--s-green-normal-active);
}

input[type="checkbox"]:checked {
  border-color: var(--s-green-normal-active);
}

input[type="checkbox"]:checked::before {
  transform: scale(1);
}
/* end categories */
.custom-multiselect {
  position: relative;
  width: 100%;
}
.multiselect-option.is-selected {
  background: var(--s-green-normal-active);
  color: #000;
}
.custom-multiselect .multiselect {
  z-index: 11;
  width: 100%;
  padding: 10px;
  height: 60px;
  margin-bottom: 24px;
  font-size: 16px;
  border: 1px solid #979797;
  border-radius: 12px;
  background-color: transparent; /* White background color */
}

.custom-multiselect .multiselect__content {
  background-color: transparent; /* White background for options */
}
.multiselect {
  background: transparent;
}
.custom-multiselect-selected .multiselect {
  border: 1px solid var(--s-green-normal-active); /* Change to desired color when a value is selected */
}
.multiselect-dropdown {
  background-color: white;
  z-index: 1000;
}
.header-container {
  display: flex;
  width: 100%;
  background-color: var(--s-pink-light);
  padding: 32px 10px;
}
.profile-image-container {
  display: flex;
  justify-content: center;
}
.profile-image {
  width: 115px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

.profile-image img {
  width: 100px;
  height: 100px;
  border-radius: 12px;
}

.profile-image input[type="file"] {
  display: none;
}
.edit-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
}
.caregiver-rating {
  color: #ffd700;
}

.star {
  font-size: 20px;
  margin-right: 6px;
}

.star.filled {
  color: #ffcc00;
}

.star:not(.filled) {
  color: #ddd;
}
h4 {
  margin: 0px;
  font-size: 28px;
  font-weight: 700;
  line-height: 36.4px;
  letter-spacing: 0.5px;
  text-align: left;
}
.header-container-details-first-div {
  display: flex;
  gap: 27px;
}
.header-container-details-first-div-svg {
  gap: 16px;
  display: flex;
  align-items: center;
}
.header-container-details {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 16px;
}
.main-dashboard-container {
  display: flex;
  gap: 71px;
}
.category-text-class {
  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-bottom: 16px;
}
h5 {
  margin-top: 10px;
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0.5px;
  text-align: left;
}
.faint-text {
  color: #979797;
}
.bio-section textarea {
  display: flex;
  flex-direction: column;
  height: 197px;
  width: 100%;
  padding: 16px;
  background-color: transparent;
  gap: 10px;
  border-radius: 12px;
  box-sizing: border-box;
  border: 1px solid #979797;
  margin-top: 16px;
}
.the-container {
  width: 100%;
  display: flex;
  width: 767px;
  border: 1px solid #979797;
  border-radius: 12px;
  flex-direction: column;
  margin-bottom: 32px;
}
.the-container-first {
  display: flex;
  width: 100%;
  border-radius: 12px;
}
.account-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 0px;
  margin: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #979797;
}
.details-container {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #979797;
  margin-bottom: 32px;
  margin-left: 16px;
  margin-right: 16px;
  padding-bottom: 16px;
  gap: 16px;
}
.details-container div {
  display: flex;
  gap: 8px;
}
h3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: justified;
  align-items: center;
  margin: 0px;
}
p {
  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: justified;
}
.change-password {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 16px;
  margin-bottom: 32px;
}
.delete-account {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 16px;
  margin-bottom: 32px;
}
.delete-account p {
  color: var(--state-error);
}
.details-last-container {
  display: flex;
  gap: 16px;
  flex-direction: column;
  padding: 16px;
}

.details-last-container > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.state-select {
  position: relative;
  z-index: 2;
}

.city-select {
  position: relative;
  z-index: 1;
}

.state-select .multiselect--active .multiselect__content-wrapper {
  z-index: 3;
}

.city-select .multiselect--active .multiselect__content-wrapper {
  z-index: 2;
}

.custom-multiselect :deep(.multiselect-single-label) {
  padding-left: 0px !important;
}

.custom-multiselect :deep(.multiselect-single-label-text) {
  font-size: 14px;
}
.custom-multiselect :deep(.multiselect-clear-icon) {
  display: none;
}
.custom-multiselect :deep(.multiselect-option.is-selected) {
  background: #17865f;
}
/* label{
    font-size: 12px;
font-weight: 400;
line-height: 20.4px;
letter-spacing: 0.5px;
text-align: left;

  color:#979797;
} */
.delete-div {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
label {
  font-size: 12px;
  font-weight: 400;
  line-height: 20.4px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-bottom: 5px;
  color: #17865f;
}
@media (max-width: 800px) {
  .overall-container {
    padding: 0px;
  }
  .dashboard-main-container {
    width: 100%;
    align-items: center;
  }
  .the-container {
    width: 300px;
  }
  .account-info-header {
    justify-content: flex-start;
  }
  .header-container {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
  .delete-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
  .header-container-details-first-div {
    flex-direction: column;
  }
  p {
    font-size: 12px;
  }
}
</style>

